import {
  Directive,
  HostListener,
  Input,
  EventEmitter,
  Output,
  HostBinding,
} from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Directive({
  selector: 'a[appRouteLink]',
})
export class RouteLinkDirective {
  @Input('appRouteLink') route: string | any[] | null | undefined;
  @Output() onRouteClick = new EventEmitter<MouseEvent>();

  constructor(
    private router: Router,
    private location: Location,
  ) {}

  @HostBinding('attr.href')
  get href(): string {
    if (!this.route) {
      return 'javascript:void(0)';
    }
    const commands = Array.isArray(this.route) ? this.route : [this.route];
    try {
      const urlTree = this.router.createUrlTree(commands);
      return this.location.prepareExternalUrl(
        this.router.serializeUrl(urlTree),
      );
    } catch (e) {
      return 'javascript:void(0)';
    }
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      return;
    }

    event.preventDefault();

    this.onRouteClick.emit(event);

    if (this.route) {
      const commands = Array.isArray(this.route) ? this.route : [this.route];
      this.router.navigate(commands);
    }
  }
}
